var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParticipants(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0003 17.5C15.0003 15.7319 14.2979 14.0362 13.0477 12.786C11.7975 11.5357 10.1018 10.8333 8.33366 10.8333C6.56555 10.8333 4.86986 11.5357 3.61961 12.786C2.36937 14.0362 1.66699 15.7319 1.66699 17.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33366 10.8333C10.6348 10.8333 12.5003 8.96785 12.5003 6.66667C12.5003 4.36548 10.6348 2.5 8.33366 2.5C6.03247 2.5 4.16699 4.36548 4.16699 6.66667C4.16699 8.96785 6.03247 10.8333 8.33366 10.8333Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 16.6667C18.3333 13.8583 16.6667 11.25 15 10C15.5478 9.58899 15.9859 9.04925 16.2755 8.42857C16.565 7.80789 16.6971 7.1254 16.66 6.44151C16.6229 5.75762 16.4178 5.09342 16.0629 4.50768C15.7079 3.92194 15.2141 3.43273 14.625 3.08334",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipants);
export default __webpack_public_path__ + "static/media/participants.64d02adc8810b6a372d369c540e4eca3.svg";
export { ForwardRef as ReactComponent };